"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RepositoryOwnerPanel = void 0;
var _ = _interopRequireWildcard(require("lodash"));
var _react = require("@fluentui/react");
var React = _interopRequireWildcard(require("react"));
require("./RepositoryOwnerPanel.scss");
var _metrics = require("../../metrics");
var _config = require("../../config");
var _ArtifactTagOptions = require("../Shared/Models/ArtifactTagOptions");
var _OwnerType = require("../Shared/Models/OwnerType");
var _ActiveIcmBanner = require("../Shared/Components/ActiveIcmBanner");
var _RepositoryPrivateVisibilityOptions = require("../Shared/Models/RepositoryPrivateVisibilityOptions");
var _RepositoryOwnerPanelProjectVisibility = _interopRequireDefault(require("./RepositoryOwnerPanelProjectVisibility"));
var _HeaderSection = _interopRequireDefault(require("./HeaderSection"));
var RepositoryOwnerPanelUtil = _interopRequireWildcard(require("./RepositoryOwnerPanelUtil"));
var _RepositoryOwnerPanelHeader = _interopRequireDefault(require("./RepositoryOwnerPanelHeader"));
var _RepositoryOwnerPanelFooter = _interopRequireDefault(require("./RepositoryOwnerPanelFooter"));
var _RepositoryOwnerPanelDebugControls = _interopRequireDefault(require("./RepositoryOwnerPanelDebugControls"));
var _WarningBox = require("./WarningBox");
var _ConditionalErrorMessage = require("./ConditionalErrorMessage");
var _RepositoryOwnerPanelAssignmentAndClassification = _interopRequireDefault(require("./RepositoryOwnerPanelAssignmentAndClassification"));
var RepoOwnerPanelApi = _interopRequireWildcard(require("./RepoOwnerPanelApi"));
var _queries = require("./queries");
var _useAssignmentSection2 = _interopRequireDefault(require("./hooks/useAssignmentSection"));
var _useRepoPanelQueryParams = require("./hooks/useRepoPanelQueryParams");
var _useCheckForOutdatedRepoPanelData = _interopRequireDefault(require("./hooks/useCheckForOutdatedRepoPanelData"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function _regeneratorRuntime() {
  "use strict";

  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  _regeneratorRuntime = function _regeneratorRuntime() {
    return exports;
  };
  var exports = {},
    Op = Object.prototype,
    hasOwn = Op.hasOwnProperty,
    defineProperty = Object.defineProperty || function (obj, key, desc) {
      obj[key] = desc.value;
    },
    $Symbol = "function" == typeof Symbol ? Symbol : {},
    iteratorSymbol = $Symbol.iterator || "@@iterator",
    asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
    toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }
  try {
    define({}, "");
  } catch (err) {
    define = function define(obj, key, value) {
      return obj[key] = value;
    };
  }
  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
      generator = Object.create(protoGenerator.prototype),
      context = new Context(tryLocsList || []);
    return defineProperty(generator, "_invoke", {
      value: makeInvokeMethod(innerFn, self, context)
    }), generator;
  }
  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }
  exports.wrap = wrap;
  var ContinueSentinel = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
    NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }
  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if ("throw" !== record.type) {
        var result = record.arg,
          value = result.value;
        return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }
      reject(record.arg);
    }
    var previousPromise;
    defineProperty(this, "_invoke", {
      value: function value(method, arg) {
        function callInvokeWithMethodAndArg() {
          return new PromiseImpl(function (resolve, reject) {
            invoke(method, arg, resolve, reject);
          });
        }
        return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(innerFn, self, context) {
    var state = "suspendedStart";
    return function (method, arg) {
      if ("executing" === state) throw new Error("Generator is already running");
      if ("completed" === state) {
        if ("throw" === method) throw arg;
        return doneResult();
      }
      for (context.method = method, context.arg = arg;;) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }
        if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
          if ("suspendedStart" === state) throw state = "completed", context.arg;
          context.dispatchException(context.arg);
        } else "return" === context.method && context.abrupt("return", context.arg);
        state = "executing";
        var record = tryCatch(innerFn, self, context);
        if ("normal" === record.type) {
          if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
          return {
            value: record.arg,
            done: context.done
          };
        }
        "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
      }
    };
  }
  function maybeInvokeDelegate(delegate, context) {
    var methodName = context.method,
      method = delegate.iterator[methodName];
    if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel;
    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }
  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }
  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }
  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;
      if (!isNaN(iterable.length)) {
        var i = -1,
          next = function next() {
            for (; ++i < iterable.length;) {
              if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
            }
            return next.value = undefined, next.done = !0, next;
          };
        return next.next = next;
      }
    }
    return {
      next: doneResult
    };
  }
  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), defineProperty(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (val) {
    var object = Object(val),
      keys = [];
    for (var key in object) {
      keys.push(key);
    }
    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function reset(skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) {
        "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
      }
    },
    stop: function stop() {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(exception) {
      if (this.done) throw exception;
      var context = this;
      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
          record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");
        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
            hasFinally = hasOwn.call(entry, "finallyLoc");
          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }
      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function complete(record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function finish(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    catch: function _catch(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) {
        ;
      }
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
var getClassificationFromTags = function getClassificationFromTags(tags) {
  return tags === null || tags === void 0 ? void 0 : tags.find(function (tag) {
    return tag === _ArtifactTagOptions.ArtifactTagOptions.NONPRODUCTION || tag === _ArtifactTagOptions.ArtifactTagOptions.PRODUCTION;
  });
};
var RepositoryOwnerPanel = function RepositoryOwnerPanel(_ref) {
  var onClose = _ref.onClose;
  // Query params

  var _useRepoPanelQueryPar = (0, _useRepoPanelQueryParams.useRepoPanelQueryParams)(),
    artifactIdentifier = _useRepoPanelQueryPar.artifactIdentifier,
    isLoadingArtifactIdentifier = _useRepoPanelQueryPar.isLoadingArtifactIdentifier,
    artifactValidationError = _useRepoPanelQueryPar.artifactValidationError,
    repoDetails = _useRepoPanelQueryPar.repoDetails,
    projectDetails = _useRepoPanelQueryPar.projectDetails;

  // Data queries

  var _useArtifactProductsQ = (0, _queries.useArtifactProductsQuery)(artifactIdentifier),
    initialSelectedProducts = _useArtifactProductsQ.data,
    errorLoadingProducts = _useArtifactProductsQ.error,
    isLoadingProducts = _useArtifactProductsQ.isLoading,
    refetchProducts = _useArtifactProductsQ.refetch;
  var _useArtifactOwnership = (0, _queries.useArtifactOwnershipQuery)(artifactIdentifier),
    initialArtifactOwnership = _useArtifactOwnership.data,
    errorLoadingArtifactOwnership = _useArtifactOwnership.error,
    isLoadingArtifactOwnership = _useArtifactOwnership.isLoading,
    refetchArtifactOwnership = _useArtifactOwnership.refetch;
  var _useArtifactMappingEx = (0, _queries.useArtifactMappingExamptionQuery)(artifactIdentifier),
    isArtifactExempted = _useArtifactMappingEx.data,
    errorLoadingArtifactMappingExemption = _useArtifactMappingEx.error,
    isLoadingArtifactMappingExemption = _useArtifactMappingEx.isLoading,
    refetchArtifactMappingExemption = _useArtifactMappingEx.refetch;
  var _useTagsQuery = (0, _queries.useTagsQuery)(artifactIdentifier),
    initialTags = _useTagsQuery.data,
    errorLoadingTags = _useTagsQuery.error,
    isLoadingTags = _useTagsQuery.isLoading,
    refetchTags = _useTagsQuery.refetch;
  var _useEditClassificatio = (0, _queries.useEditClassificationPermissionQuery)(artifactIdentifier),
    isUserAllowedToEditClassification = _useEditClassificatio.data;

  // Basic state

  var _React$useState = React.useState([]),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    selectedProducts = _React$useState2[0],
    setSelectedProducts = _React$useState2[1];
  var _React$useState3 = React.useState(),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    selectedClassification = _React$useState4[0],
    setSelectedClassification = _React$useState4[1];
  var _React$useState5 = React.useState({
      justification: "",
      owners: []
    }),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    selectedArtifactOwnership = _React$useState6[0],
    setSelectedArtifactOwnership = _React$useState6[1];
  var _React$useState7 = React.useState(_RepositoryPrivateVisibilityOptions.RepositoryPrivateVisibilityOptions.NameAllowed),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    repositoryPrivateVisibilityOptions = _React$useState8[0],
    setRepositoryPrivateVisibilityOptions = _React$useState8[1];
  var _React$useState9 = React.useState(false),
    _React$useState0 = _slicedToArray(_React$useState9, 2),
    isDataSubmitting = _React$useState0[0],
    setIsDataSubmitting = _React$useState0[1];
  var _React$useState1 = React.useState(false),
    _React$useState10 = _slicedToArray(_React$useState1, 2),
    errorShowingOwners = _React$useState10[0],
    setErrorShowingOwners = _React$useState10[1];
  var _React$useState11 = React.useState(null),
    _React$useState12 = _slicedToArray(_React$useState11, 2),
    errorSubmittingAssignment = _React$useState12[0],
    setErrorSubmittingAssignment = _React$useState12[1];
  var _React$useState13 = React.useState(null),
    _React$useState14 = _slicedToArray(_React$useState13, 2),
    errorSubmittingClassification = _React$useState14[0],
    setErrorSubmittingClassification = _React$useState14[1];
  var _React$useState15 = React.useState(),
    _React$useState16 = _slicedToArray(_React$useState15, 2),
    errorSubmittingArtifactMappingExemption = _React$useState16[0],
    setErrorSubmittingArtifactMappingExemption = _React$useState16[1];

  // Processed state

  var _useAssignmentSection = (0, _useAssignmentSection2.default)(initialArtifactOwnership, initialSelectedProducts, isLoadingArtifactOwnership, isLoadingArtifactMappingExemption, isLoadingProducts),
    assignmentHasInitialData = _useAssignmentSection.assignmentHasInitialData,
    isAssignmentReadonly = _useAssignmentSection.isAssignmentReadonly,
    assignmentValidity = _useAssignmentSection.assignmentValidity,
    ownerType = _useAssignmentSection.ownerType,
    setAssignmentValidity = _useAssignmentSection.setAssignmentValidity,
    setOwnerType = _useAssignmentSection.setOwnerType;
  var initialClassification = getClassificationFromTags(initialTags);
  var isClassificationReadonly = !isUserAllowedToEditClassification && initialClassification !== undefined;
  var isLoadingAssignment = isLoadingProducts || isLoadingArtifactOwnership || isLoadingArtifactMappingExemption;
  var isLoadingFormData = isLoadingAssignment || isLoadingTags;
  var isNameAllowed = repositoryPrivateVisibilityOptions === _RepositoryPrivateVisibilityOptions.RepositoryPrivateVisibilityOptions.NameAllowed;
  var assignmentError = errorLoadingProducts || errorLoadingArtifactOwnership || errorSubmittingAssignment ? new Error(t("repositoryOwnerPanel.error.productsLoadError")) : null;
  var _useCheckForOutdatedR = (0, _useCheckForOutdatedRepoPanelData.default)(artifactIdentifier, initialClassification, initialSelectedProducts, initialArtifactOwnership),
    outdatedDataError = _useCheckForOutdatedR.outdatedDataError,
    dataIsUpToDate = _useCheckForOutdatedR.dataIsUpToDate;
  React.useEffect(function () {
    if (artifactIdentifier) {
      _metrics.Metrics.trackEvent("RepositoryOwnerPanel.ViewPanel", _objectSpread({}, artifactIdentifier));
    }
  }, [artifactIdentifier]);
  React.useEffect(function () {
    if (initialClassification) {
      setSelectedClassification(initialClassification);
    }
  }, [initialClassification]);
  React.useEffect(function () {
    if (initialSelectedProducts) {
      setSelectedProducts(initialSelectedProducts.map(function (p) {
        return {
          key: p.id,
          name: p.name
        };
      }));
    }
  }, [initialSelectedProducts]);
  React.useEffect(function () {
    if (initialArtifactOwnership) {
      setSelectedArtifactOwnership(initialArtifactOwnership);
    }
  }, [initialArtifactOwnership]);

  // Functions

  var setDirectOwnerIsValid = React.useCallback(function (isValid) {
    var _setAssignmentValidit;
    setAssignmentValidity((_setAssignmentValidit = {}, _defineProperty(_setAssignmentValidit, _OwnerType.OwnerType.PERSON, isValid), _defineProperty(_setAssignmentValidit, _OwnerType.OwnerType.SERVICE, assignmentValidity.service), _setAssignmentValidit));
  }, [assignmentValidity.service, setAssignmentValidity]);
  var setServiceIsValid = React.useCallback(function (isValid) {
    var _setAssignmentValidit2;
    setAssignmentValidity((_setAssignmentValidit2 = {}, _defineProperty(_setAssignmentValidit2, _OwnerType.OwnerType.PERSON, assignmentValidity.directowner), _defineProperty(_setAssignmentValidit2, _OwnerType.OwnerType.SERVICE, isValid), _setAssignmentValidit2));
  }, [assignmentValidity.directowner, setAssignmentValidity]);
  var onArtifactOwnershipChange = React.useCallback(function (ownership, isValid) {
    if (isValid && ownership !== null) {
      setSelectedArtifactOwnership(ownership);
    }
    setDirectOwnerIsValid(isValid);
  }, [setSelectedArtifactOwnership, setDirectOwnerIsValid]);
  var onSelectedProductsChange = React.useCallback(function (products, isValid) {
    if (isValid && products) {
      setSelectedProducts(products);
    }
    setServiceIsValid(isValid);
  }, [setSelectedProducts, setServiceIsValid]);
  var closePanel = function closePanel() {
    _metrics.Metrics.trackEvent("RepositoryOwnerPanel.Close", _objectSpread({}, artifactIdentifier));
    onClose();
  };
  React.useEffect(function () {
    if (artifactIdentifier) {
      _metrics.Metrics.trackEvent("RepositoryOwnerPanel.ViewPanel", _objectSpread({}, artifactIdentifier));
    }
  }, [artifactIdentifier]);
  var focusTrapZone = undefined;
  var submitExemption = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(artifactIdentifier) {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              setIsDataSubmitting(true);
              setErrorSubmittingArtifactMappingExemption(null);
              _context.next = 5;
              return RepoOwnerPanelApi.submitArtifactMappingExemption(artifactIdentifier);
            case 5:
              _context.next = 7;
              return refetchArtifactMappingExemption();
            case 7:
              _context.next = 12;
              break;
            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](0);
              setErrorSubmittingArtifactMappingExemption(Error("Could not create exemption. Please refresh."));
            case 12:
              _context.prev = 12;
              setIsDataSubmitting(false);
              return _context.finish(12);
            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 9, 12, 15]]);
    }));
    return function submitExemption(_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
  var submitData = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
      var _focusTrapZone;
      var isAssignmentInputValid, isClassificationSelected, canAssignmentBeSubmitted, canClassificationBeSubmitted, isUpToDate;
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              (_focusTrapZone = focusTrapZone) === null || _focusTrapZone === void 0 ? void 0 : _focusTrapZone.focus();
              if (!(artifactIdentifier === null)) {
                _context5.next = 3;
                break;
              }
              return _context5.abrupt("return");
            case 3:
              if (isNameAllowed) {
                _context5.next = 7;
                break;
              }
              _context5.next = 6;
              return submitExemption(artifactIdentifier);
            case 6:
              return _context5.abrupt("return");
            case 7:
              // If name is allowed (i.e. RepositoryPrivateVisibilityOptions.NameAllowed)
              // the repo will be assigned and classified.
              setErrorShowingOwners(true);
              isAssignmentInputValid = RepositoryOwnerPanelUtil.isAssignmentValid(isAssignmentReadonly, assignmentValidity, ownerType);
              isClassificationSelected = Boolean(selectedClassification && artifactIdentifier);
              if (!isClassificationReadonly && !isClassificationSelected) {
                setErrorSubmittingClassification(new Error(t("repositoryOwnerPanel.error.required")));
              }
              canAssignmentBeSubmitted = isAssignmentReadonly || isAssignmentInputValid;
              canClassificationBeSubmitted = isClassificationReadonly || isClassificationSelected; // "assignment" and "classification" cannot be both valid by both being
              // read-only at the same time. We prevent this by disabling relevant UI button.
              // Even so, in such case no promises would execute, as they would both be null.
              if (!(canAssignmentBeSubmitted && canClassificationBeSubmitted)) {
                _context5.next = 46;
                break;
              }
              setIsDataSubmitting(true);
              _context5.next = 17;
              return dataIsUpToDate();
            case 17:
              isUpToDate = _context5.sent;
              if (isUpToDate) {
                _context5.next = 22;
                break;
              }
              setIsDataSubmitting(false);
              _metrics.Metrics.trackEvent("RepositoryOwnerPanel.Save.Fail.OutdatedData", _objectSpread({}, artifactIdentifier));
              return _context5.abrupt("return");
            case 22:
              _context5.prev = 22;
              if (!canClassificationBeSubmitted) {
                _context5.next = 28;
                break;
              }
              _context5.next = 26;
              return RepositoryOwnerPanelUtil.submitClassification(setErrorSubmittingClassification, /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
                return _regeneratorRuntime().wrap(function _callee2$(_context2) {
                  while (1) {
                    switch (_context2.prev = _context2.next) {
                      case 0:
                        if (!selectedClassification) {
                          _context2.next = 3;
                          break;
                        }
                        _context2.next = 3;
                        return RepoOwnerPanelApi.submitClassification(selectedClassification, artifactIdentifier);
                      case 3:
                      case "end":
                        return _context2.stop();
                    }
                  }
                }, _callee2);
              })));
            case 26:
              _context5.next = 28;
              return refetchTags();
            case 28:
              if (!canAssignmentBeSubmitted) {
                _context5.next = 38;
                break;
              }
              _context5.next = 31;
              return RepositoryOwnerPanelUtil.submitAssignment(isAssignmentReadonly, ownerType, setErrorSubmittingAssignment, /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
                return _regeneratorRuntime().wrap(function _callee3$(_context3) {
                  while (1) {
                    switch (_context3.prev = _context3.next) {
                      case 0:
                        _context3.next = 2;
                        return RepoOwnerPanelApi.submitSelectedProducts(artifactIdentifier, selectedProducts);
                      case 2:
                        return _context3.abrupt("return", _context3.sent);
                      case 3:
                      case "end":
                        return _context3.stop();
                    }
                  }
                }, _callee3);
              })), /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
                return _regeneratorRuntime().wrap(function _callee4$(_context4) {
                  while (1) {
                    switch (_context4.prev = _context4.next) {
                      case 0:
                        _context4.next = 2;
                        return RepoOwnerPanelApi.submitArtifactOwnership(artifactIdentifier, selectedArtifactOwnership);
                      case 2:
                        return _context4.abrupt("return", _context4.sent);
                      case 3:
                      case "end":
                        return _context4.stop();
                    }
                  }
                }, _callee4);
              })));
            case 31:
              if (!(ownerType === _OwnerType.OwnerType.SERVICE)) {
                _context5.next = 36;
                break;
              }
              _context5.next = 34;
              return refetchProducts();
            case 34:
              _context5.next = 38;
              break;
            case 36:
              _context5.next = 38;
              return refetchArtifactOwnership();
            case 38:
              if (canClassificationBeSubmitted && canAssignmentBeSubmitted) {
                _metrics.Metrics.trackEvent("RepositoryOwnerPanel.Save.Success.Both", _objectSpread({}, artifactIdentifier));
                window.location.reload();
              } else if (canClassificationBeSubmitted) {
                _metrics.Metrics.trackEvent("RepositoryOwnerPanel.Save.Success.ClassificationOnly", _objectSpread({}, artifactIdentifier));
                window.location.reload();
              } else if (canAssignmentBeSubmitted) {
                _metrics.Metrics.trackEvent("RepositoryOwnerPanel.Save.Success.AssignmentOnly", _objectSpread({}, artifactIdentifier));
                window.location.reload();
              } else {
                _metrics.Metrics.trackEvent("RepositoryOwnerPanel.Save.Fail.NoDataSubmitted", _objectSpread({}, artifactIdentifier));
              }
              _context5.next = 44;
              break;
            case 41:
              _context5.prev = 41;
              _context5.t0 = _context5["catch"](22);
              // Passes client validation, but fails backend validation
              _metrics.Metrics.trackEvent("RepositoryOwnerPanel.Save.Fail.ServerValidation", _objectSpread({}, artifactIdentifier));
            case 44:
              _context5.next = 47;
              break;
            case 46:
              _metrics.Metrics.trackEvent("RepositoryOwnerPanel.Save.Fail.ClientValidation", _objectSpread({}, artifactIdentifier));
            case 47:
              setIsDataSubmitting(false);
            case 48:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, null, [[22, 41]]);
    }));
    return function submitData() {
      return _ref3.apply(this, arguments);
    };
  }();
  if (artifactValidationError !== null) {
    return /*#__PURE__*/React.createElement(_react.Panel, {
      onDismiss: closePanel,
      type: _react.PanelType.medium,
      isOpen: true,
      headerText: artifactValidationError.title
    }, /*#__PURE__*/React.createElement("div", {
      className: "message-bar-wrapper"
    }, /*#__PURE__*/React.createElement(_ConditionalErrorMessage.ConditionalErrorMessage, {
      error: artifactValidationError
    })));
  }
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(_RepositoryOwnerPanelDebugControls.default, {
    artifactIdentifier: artifactIdentifier
  }), /*#__PURE__*/React.createElement(_react.FocusTrapZone, {
    className: "flex-column flex-grow scroll-auto",
    componentRef: function componentRef(zone) {
      return focusTrapZone = zone;
    }
  }, /*#__PURE__*/React.createElement(_react.Panel, {
    className: "repository-ownership-panel",
    onDismiss: closePanel,
    type: _react.PanelType.medium,
    isBlocking: _config.Config.isDebugMode ? false : true,
    isOpen: true,
    onRenderHeader: function onRenderHeader() {
      return /*#__PURE__*/React.createElement(_RepositoryOwnerPanelHeader.default, {
        isLoading: isLoadingArtifactIdentifier,
        repoDetails: repoDetails
      });
    },
    isFooterAtBottom: true,
    onRenderFooter: function onRenderFooter() {
      return /*#__PURE__*/React.createElement(_RepositoryOwnerPanelFooter.default, {
        closePanel: closePanel,
        isLoading: isLoadingArtifactIdentifier || isLoadingFormData || isDataSubmitting,
        isSubmitting: isDataSubmitting,
        submitData: submitData,
        submitIsDisabled: isAssignmentReadonly && isClassificationReadonly ||
        // disable the submit button if in the edit experience and none of the provided input data has changed.
        assignmentHasInitialData && initialTags !== undefined && initialClassification === selectedClassification && ownerType === _OwnerType.OwnerType.PERSON && initialArtifactOwnership !== undefined && _.isEqual(initialArtifactOwnership.owners, selectedArtifactOwnership.owners) && _.isEqual(initialArtifactOwnership.justification, selectedArtifactOwnership.justification) && repositoryPrivateVisibilityOptions !== _RepositoryPrivateVisibilityOptions.RepositoryPrivateVisibilityOptions.NameNotAllowed,
        repoIsExempted: isArtifactExempted !== null && isArtifactExempted !== void 0 ? isArtifactExempted : false
      });
    }
  }, /*#__PURE__*/React.createElement(_react.Stack, {
    style: {
      width: "100%"
    },
    tokens: {
      childrenGap: 16
    }
  }, /*#__PURE__*/React.createElement(_HeaderSection.default, {
    repositoryIsExempted: isArtifactExempted !== null && isArtifactExempted !== void 0 ? isArtifactExempted : false,
    isLoading: isLoadingArtifactIdentifier || isLoadingFormData
  }), /*#__PURE__*/React.createElement(_ActiveIcmBanner.ActiveIcmBanner, null), /*#__PURE__*/React.createElement(_ConditionalErrorMessage.ConditionalErrorMessage, {
    error: outdatedDataError
  }), /*#__PURE__*/React.createElement(_ConditionalErrorMessage.ConditionalErrorMessage, {
    error: errorLoadingArtifactMappingExemption !== null && errorLoadingArtifactMappingExemption !== void 0 ? errorLoadingArtifactMappingExemption : errorSubmittingArtifactMappingExemption
  }), !isArtifactExempted && !isAssignmentReadonly && /*#__PURE__*/React.createElement(_RepositoryOwnerPanelProjectVisibility.default, {
    projectVisibility: projectDetails.visibility,
    setRepositoryPrivateVisibilityOptions: setRepositoryPrivateVisibilityOptions,
    repositoryPrivateVisibilityOptions: repositoryPrivateVisibilityOptions
  }), !isArtifactExempted && isNameAllowed && initialArtifactOwnership && initialSelectedProducts && /*#__PURE__*/React.createElement(_react.Stack, {
    style: {
      width: "100%"
    },
    tokens: {
      childrenGap: 16
    }
  }, /*#__PURE__*/React.createElement(_RepositoryOwnerPanelAssignmentAndClassification.default, {
    classification: selectedClassification,
    classificationError: errorLoadingTags !== null && errorLoadingTags !== void 0 ? errorLoadingTags : errorSubmittingClassification,
    assignmentError: assignmentError,
    disabled: isDataSubmitting,
    isLoading: isLoadingArtifactIdentifier || isLoadingTags,
    setClassification: setSelectedClassification,
    isLoadingAssignment: isLoadingArtifactIdentifier || isLoadingAssignment,
    isSubmittingAssignment: isDataSubmitting,
    isAssignmentReadonly: isAssignmentReadonly,
    ownerPickerProps: {
      defaultArtifactOwnership: initialArtifactOwnership,
      disabled: isAssignmentReadonly || isDataSubmitting,
      showError: errorShowingOwners,
      onChange: onArtifactOwnershipChange
    },
    ownerType: ownerType,
    serviceTreePickerProps: {
      disabled: isAssignmentReadonly || isDataSubmitting,
      defaultProducts: initialSelectedProducts,
      onChange: onSelectedProductsChange
    },
    setOwnerType: setOwnerType
  })), !isArtifactExempted && !isNameAllowed && /*#__PURE__*/React.createElement(_WarningBox.WarningBox, null)))));
};
exports.RepositoryOwnerPanel = RepositoryOwnerPanel;